import React from "react";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$lang/notfound")({
  component: React.lazy(() =>
    import("@/pages/errorPages/notFound").then((mod) => ({
      default: mod.NotFound,
    })),
  ),
});
